import { get, post } from '../utils/axios'

export const getRighMenuProfiletOrgAPI = async () => {
  return await get('right/menu/profiles/user')
}

export const getRightOrgAPI = async (body) => {
  return await get('right/org', body)
}

export const getSearchUsernameAPI = async (body) => {
  return await get('right/search/username', body)
}

export const getRightOrgDetailAPI = async (body) => {
  return await get('right/org/detail', body)
}

export const postRightOrgDetailAPI = async (param) => {
  return await post('right/org/post', param)
}

export const putRightOrgDetailAPI = async (body) => {
  return await post('right/org/all/put', body)
}
